import React from 'react';
import { useLocation } from 'react-router-dom';

export default function Sidebar({
  ownerUnits = [],
  activeTab,
  setActiveTab = () => {},
  setShowAddUnitForm = () => {},
  setEditingUnitId = () => {},
  onLogout = () => {},
  mobileMenuOpen = false,
  setMobileMenuOpen = () => {},
  /** Pending outbound professional invites (owner dashboard). */
  ownerInviteBadge = 0,
}) {
  const location = useLocation();

  return (
    <div className={`dashboard-sidebar ${mobileMenuOpen ? 'open' : ''}`}>
      <h2>Owner Portal</h2>

      <div
        className={`nav-item ${activeTab === 'dashboard' ? 'active' : ''}`}
        onClick={() => {
          setActiveTab('dashboard');
          setShowAddUnitForm(false);
          setEditingUnitId(null);
          setMobileMenuOpen(false);
        }}
      >
        📊 Dashboard
      </div>

      <div
        className={`nav-item ${activeTab === 'report' ? 'active' : ''}`}
        onClick={() => {
          setActiveTab('report');
          setShowAddUnitForm(false);
          setEditingUnitId(null);
          setMobileMenuOpen(false);
        }}
      >
        📈 Report
      </div>

      <div
        className={`nav-item ${activeTab === 'units' ? 'active' : ''}`}
        data-owner-tip-target="owner-manage-units"
        onClick={() => {
          setActiveTab('units');
          setShowAddUnitForm(false);
          setEditingUnitId(null);
          setMobileMenuOpen(false);
        }}
      >
        🏢 All units
      </div>

      <div
        className={`nav-item ${(location.pathname === '/owner/tenants' || activeTab === 'tenants') ? 'active' : ''}`}
        onClick={() => {
          setActiveTab('tenants');
          setShowAddUnitForm(false);
          setEditingUnitId(null);
          setMobileMenuOpen(false);
        }}
      >
        👥 Active Tenants
      </div>

      <div
        className={`nav-item ${activeTab === 'all-requests' ? 'active' : ''}`}
        data-owner-tip-target="owner-all-requests"
        onClick={() => {
          setActiveTab('all-requests');
          setShowAddUnitForm(false);
          setEditingUnitId(null);
          setMobileMenuOpen(false);
        }}
      >
        📋 All Requests
      </div>

      <div
        className={`nav-item ${activeTab === 'preferred-pros' ? 'active' : ''}`}
        onClick={() => {
          setActiveTab('preferred-pros');
          setShowAddUnitForm(false);
          setEditingUnitId(null);
          setMobileMenuOpen(false);
        }}
        style={ownerInviteBadge > 0 ? { position: 'relative' } : undefined}
      >
        🔧 Preferred pros
        {ownerInviteBadge > 0 ? (
          <span
            style={{
              marginLeft: '8px',
              display: 'inline-block',
              minWidth: '20px',
              padding: '2px 7px',
              borderRadius: '999px',
              fontSize: '11px',
              fontWeight: 800,
              background: '#ea580c',
              color: '#fff',
              verticalAlign: 'middle',
            }}
          >
            {ownerInviteBadge > 99 ? '99+' : ownerInviteBadge}
          </span>
        ) : null}
      </div>

      <div
        className={`nav-item ${activeTab === 'applicants' ? 'active' : ''}`}
        onClick={() => {
          setActiveTab('applicants');
          setShowAddUnitForm(false);
          setEditingUnitId(null);
          setMobileMenuOpen(false);
        }}
      >
        📩 Applicants
      </div>

      <div
        className="nav-item logout-nav-item"
        onClick={() => { setMobileMenuOpen(false); onLogout(); }}
      >
        🚪 Logout
      </div>

      <div
        className={`nav-item ${activeTab === 'settings' ? 'active' : ''}`}
        onClick={() => {
          setActiveTab('settings');
          setShowAddUnitForm(false);
          setEditingUnitId(null);
          setMobileMenuOpen(false);
        }}
      >
        ⚙️ Settings
      </div>

      <div className="sidebar-footer">v1.0</div>
    </div>
  );
}
